import {
  HSUC
} from 'hsuc'
const HSUC_VUE_APP_AD_URL = new HSUC({
  appCode: 101,
  baseURL: process.env.VUE_APP_AD_URL,
  debug: false
})

const HSUC_VUE_APP_YAF_URL = new HSUC({
  appCode: 140,
  baseURL: process.env.VUE_APP_YAF_URL,
  debug: false
})

const HSUC_VUE_APP_MKTGO_URL = new HSUC({
  appCode: 112,
  baseURL: process.env.VUE_APP_MKTGO_URL,
  debug: false
})

const HSUC_VUE_APP_MMC_URL = new HSUC({
  appCode: 112,
  baseURL: process.env.VUE_APP_MMC_URL,
  debug: false
})

const HSUC_VUE_APP_UC_URL = new HSUC({
  appCode: 105,
  baseURL: process.env.VUE_APP_UC_URL,
  debug: false
})

const HSUC_VUE_APP_ADS_URL = new HSUC({
  appCode: 120,
  baseURL: process.env.VUE_APP_ADS_URL,
  debug: false
})

const HSUC_VUE_APP_ALB_URL = new HSUC({
  appCode: 140,
  baseURL: process.env.VUE_APP_ALB_URL,
  debug: false
})
const HSUC_VUE_APP_MESSAGE_URL = new HSUC({
  appCode: 140,
  baseURL: process.env.VUE_APP_MESSAGE_URL,
  debug: false
})
export {
  HSUC_VUE_APP_AD_URL,
  HSUC_VUE_APP_YAF_URL,
  HSUC_VUE_APP_MKTGO_URL,
  HSUC_VUE_APP_MMC_URL,
  HSUC_VUE_APP_UC_URL,
  HSUC_VUE_APP_ADS_URL,
  HSUC_VUE_APP_ALB_URL,
  HSUC_VUE_APP_MESSAGE_URL
}